(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.pdpfInit === '1') return;
    section.dataset.pdpfInit = '1';

    var allowMultiple = section.classList.contains('section-pdpf--multi') ||
                        section.dataset.pdpfMultiple === 'true';
    var items = Array.from(section.querySelectorAll('[data-pdpf-item]'));
    if (items.length === 0) return;

    function getButton(item) { return item.querySelector('[data-pdpf-toggle]'); }
    function getPanel(item) { return item.querySelector('[data-pdpf-panel]'); }

    function open(item) {
      var btn = getButton(item);
      var panel = getPanel(item);
      if (!btn || !panel) return;
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    function close(item) {
      var btn = getButton(item);
      var panel = getPanel(item);
      if (!btn || !panel) return;
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = '0px';
    }

    items.forEach(function (item) {
      var btn = getButton(item);
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        if (!allowMultiple) {
          items.forEach(function (other) {
            if (other !== item) close(other);
          });
        }
        isOpen ? close(item) : open(item);
      });

      // Initial state — if Liquid pre-marked is-open, set max-height
      if (item.classList.contains('is-open')) {
        // Wait a frame so layout has settled
        requestAnimationFrame(function () { open(item); });
      }
    });

    // Recompute open panel heights on resize so wrapping reflows correctly
    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        items.forEach(function (item) {
          if (!item.classList.contains('is-open')) return;
          var panel = getPanel(item);
          if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      });
    });
  }

  function readMultipleSetting(section) {
    // The schema has `allow_multiple` as a section setting. Liquid adds it
    // via a data attribute below in the template, so JS reads it from there.
    return section.dataset.pdpfMultiple === 'true';
  }

  function initAll() {
    document.querySelectorAll('.section-pdpf').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('.section-pdpf') : null;
    if (s) initSection(s);
  });
})();
